export default __webpack_public_path__ + "static/media/ad.828d9d8c.svg";